import { Box } from '@mui/material';

export default function DeviceTableColumn({ columnValue }: { columnValue: string }) {
    return (
        <Box
            sx={{
                display: 'block',
                width: '100%',
                maxWidth: '100%',
                minWidth: 0,
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap !important',
            }}
            title={columnValue}
        >
            {columnValue}
        </Box>
    );
}
